<template>
  <el-cascader
    ref="cascader"
    v-loading="areaLoading"
    :value="value"
    clearable
    :options="areaTree"
    :props="props"
    filterable
    v-bind="$attrs"
    @change="change"
  />
</template>

<script>
import { mapState } from 'vuex'
import { dispatch } from '@/utils/agreementUtil'
export default {
  name: 'AreaSelect',
  components: {},
  props: {
    value: {
      type: [Array, String],
      default: () => []
    }
  },
  data() {
    return {
      props: {
        value: 'regionId',
        label: 'regionName'
      },
      options: []
    }
  },
  computed: {
    ...mapState({
      areaLoading: (state) => state.user.areaLoading,
      areaTree: (state) => state.user.areaTree
    })
  },

  async created() {
    this.$store.dispatch('user/queryTree')
  },
  methods: {
    getRegionName() {
      if (this.$refs.cascader.getCheckedNodes()[0]) {
        return this.$refs.cascader.getCheckedNodes()[0].pathLabels.join('-')
      }
      return ''
    },
    onSearch() {
      this.value.pageNumber = 1
      this.$emit('onSearch')
    },
    addNew() {
      this.$emit('addNew')
    },
    batchDelete() {
      this.$emit('batchDelete')
    },
    change(e) {
      this.$emit('input', e)
      this.$emit('areaChange', this.getRegionName(), e)
      dispatch.call(this, 'ElFormItem', 'el.form.blur', [e])
    }
  }
}
</script>

<style lang="scss" scoped>
.el-cascader {
  width: 100%;
}
</style>
